
export default function (ListParcel) {
     return class ItemsFetchParcel extends ListParcel {
        constructor(ids) {

            const filters = [
                {field: 'id', operator: 'in_list', value: ids}
            ];

            const filtersConfig = {
                id: {type: 'selectable'},
            };

            const orders = [{
                key: 'id',
                isAsc: false
            }];

            super({filters, filtersConfig, orders});
        }
    }
}
